import get from 'lodash/get';

import i18n from 'shared/lib/i18n';

import {
  CLEAR_INVITE_INFO,
  EXPIRE_VISITORS_FAILURE,
  EXPIRE_VISITORS_REQUESTED,
  EXPIRE_VISITORS_SUCCEEDED,
  GET_INVITE_INFO_FAILURE,
  GET_INVITE_INFO_REQUEST,
  GET_INVITE_INFO_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_VISITORS_FAILURE,
  GET_VISITORS_LOG_FAILURE,
  GET_VISITORS_LOG_REQUEST,
  GET_VISITORS_LOG_SUCCESS,
  GET_VISITORS_REQUESTED,
  GET_VISITORS_SUCCEEDED,
  GET_VISITOR_INFO_BY_CREATOR_ID_FAILURE,
  GET_VISITOR_INFO_BY_CREATOR_ID_REQUEST,
  GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS,
  GET_VISITOR_INFO_BY_ID_FAILURE,
  GET_VISITOR_INFO_BY_ID_REQUEST,
  GET_VISITOR_INFO_BY_ID_SUCCESS,
  LOG_VISITOR_ENTRY_FAILURE,
  LOG_VISITOR_ENTRY_REQUEST,
  LOG_VISITOR_ENTRY_SUCCESS,
  SELECT_EXISTING_CLEAR_PEOPLE,
  SELECT_EXISTING_LOAD_PEOPLE,
  SET_MODAL_TYPE,
  SET_NEW_VISITOR_FAILURE,
  SET_NEW_VISITOR_REQUESTED,
  SET_NEW_VISITOR_SUCCEEDED,
  UPDATE_INVITE_INFO_FAILURE,
  UPDATE_INVITE_INFO_REQUEST,
  UPDATE_INVITE_INFO_SUCCESS,
  UPDATE_NEW_VISITOR_FAILURE,
  UPDATE_NEW_VISITOR_REQUESTED,
  UPDATE_NEW_VISITOR_SUCCEEDED,
  UPLOAD_FILES_FAILURE,
  UPLOAD_FILES_REQUEST,
  UPLOAD_FILES_SUCCESS,
  VISITOR_INVITE_DELETE,
  VISITOR_INVITE_RESEND,
  VISITOR_INVITE_SEND,
} from '../../actionConstants';

import { sendGA4Event } from '../Shared/utils/ga';

import apiClient from '../../apiClient';
import { handleFormError } from '../../middleware';
import { INFO } from '../Modal/modalTypes';

export const getVisitorsList = (dispatch, queryParams = {}, isExport) =>
  dispatch({
    type: GET_VISITORS_REQUESTED,
    withoutLoading: isExport,
    payload: apiClient.visitors.get(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_VISITORS_SUCCEEDED,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_VISITORS_FAILURE,
          err,
        }),
    ),
  });

export const getVisitorsLog = (dispatch, queryParams = {}, isExport) =>
  dispatch({
    type: GET_VISITORS_LOG_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.visitors.getLog(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_VISITORS_LOG_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: GET_VISITORS_LOG_FAILURE,
          err,
        }),
    ),
  });

// TODO - consider moving to forms
export const uploadImage = (dispatch, images, url, type) => {
  if (!images?.length || !url) return null;

  const formData = new FormData();

  images.forEach((file) => {
    formData.append(file.name, file);
  });

  if (type) {
    // currently is used only in LogoUploadContainer
    formData.append('type', type);
  }

  const successMessage = i18n.t('popup.image_sUploaded');

  return dispatch({
    type: UPLOAD_FILES_REQUEST,
    payload: apiClient.image.upload(url, formData).then(
      (res) => {
        sendGA4Event('upload_item');
        dispatch({ type: UPLOAD_FILES_SUCCESS, res, successMessage });
        return res?.data?.length > 0;
      },
      (err) => dispatch({ type: UPLOAD_FILES_FAILURE, err }),
    ),
    isForm: false,
  });
};

export const onPersonSubmit = (dispatch, data, type, props) => {
  const { match } = props;
  const personId =
    get(match, 'params.visitorId') || get(match, 'params.brokerId');
  const isUpdate = !!personId;

  const { images, ...rest } = data;

  return dispatch({
    type: isUpdate ? UPDATE_NEW_VISITOR_REQUESTED : SET_NEW_VISITOR_REQUESTED,
    isForm: true,
    payload: (isUpdate
      ? apiClient.visitors.updateVisitor(rest, personId)
      : apiClient.visitors[`create${type}`](rest)
    ).then(
      async (res) => {
        if (res.data.created || res.data.updated) {
          type === i18n.t('title.visitor') &&
            res.data.created &&
            sendGA4Event('created_visitor');

          const newVisitor = res.data;
          dispatch({
            type: isUpdate
              ? UPDATE_NEW_VISITOR_SUCCEEDED
              : SET_NEW_VISITOR_SUCCEEDED,
            res,
            successMessage: isUpdate
              ? i18n.t('popup.updated')
              : i18n.t('popup.created'),
          });

          const url = res.data.photoUploadUrl;
          await uploadImage(dispatch, images, url);

          return newVisitor;
        }
        dispatch({
          type: SELECT_EXISTING_LOAD_PEOPLE,
          people: res.data.persons,
        });
        return false;
      },
      (err) => {
        dispatch({
          type: isUpdate ? UPDATE_NEW_VISITOR_FAILURE : SET_NEW_VISITOR_FAILURE,
          err,
        });
        return handleFormError(err);
      },
    ),
  });
};

export const onSubmitComplete = (dispatch, data, type, props) => {
  const { match, isUpdate } = props;
  const personId =
    get(match, 'params.visitorId') || get(match, 'params.brokerId');
  return dispatch({
    type: isUpdate ? UPDATE_NEW_VISITOR_REQUESTED : SET_NEW_VISITOR_REQUESTED,
    payload: (isUpdate
      ? apiClient.visitors.completeVisitorUpdate(data, personId)
      : apiClient.visitors[`complete${type}Creation`](data)
    ).then(
      (res) => {
        dispatch({
          type: isUpdate
            ? UPDATE_NEW_VISITOR_SUCCEEDED
            : SET_NEW_VISITOR_SUCCEEDED,
          successMessage: isUpdate
            ? i18n.t('popup.updated')
            : i18n.t('popup.created'),
        });
        return res?.data;
      },
      (err) => {
        dispatch({
          type: isUpdate ? UPDATE_NEW_VISITOR_FAILURE : SET_NEW_VISITOR_FAILURE,
          err,
        });
        return null;
      },
    ),
  });
};

export const sendInvite = (dispatch, data, visitorId, hasInvite, queryParams) =>
  dispatch({
    type: hasInvite ? VISITOR_INVITE_RESEND : VISITOR_INVITE_SEND,
    payload: (hasInvite
      ? apiClient.visitors.resendInvite(visitorId)
      : apiClient.visitors.sendInvite(data, visitorId)
    ).then(() => {
      if (!queryParams) return;
      getVisitorsList(dispatch, queryParams);
    }),
    successMessage: hasInvite
      ? i18n.t('popup.inviteResent')
      : i18n.t('popup.inviteSent'),
  });

export const deleteInvite = (dispatch, visitorId, queryParams) =>
  dispatch({
    type: VISITOR_INVITE_DELETE,
    payload: apiClient.visitors.deleteInvite(visitorId).then(() => {
      getVisitorsList(dispatch, queryParams);
    }),
    successMessage: i18n.t('popup.inviteDeleted'),
  });

export const expireVisitor = (dispatch, visitorId, queryParams) =>
  dispatch({
    type: EXPIRE_VISITORS_REQUESTED,
    payload: apiClient.visitors.expireVisitor(visitorId).then(
      () => {
        dispatch({
          type: EXPIRE_VISITORS_SUCCEEDED,
        });
        getVisitorsList(dispatch, queryParams);
      },
      (err) => {
        dispatch({
          type: EXPIRE_VISITORS_FAILURE,
          err,
        });
      },
    ),
  });

export const clearExistingVisitor = (dispatch) =>
  dispatch({ type: SELECT_EXISTING_CLEAR_PEOPLE });

export const getInviteInfo = (dispatch, visitorId) =>
  dispatch({
    type: GET_INVITE_INFO_REQUEST,
    payload: apiClient.visitors.getInviteInfo(visitorId).then(
      (res) =>
        dispatch({
          type: GET_INVITE_INFO_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_INVITE_INFO_FAILURE,
          err,
        }),
    ),
  });

export const updateInviteInfo = (dispatch, visitorId, data) =>
  dispatch({
    type: UPDATE_INVITE_INFO_REQUEST,
    payload: apiClient.visitors.updateInvite(visitorId, data).then(
      (res) =>
        dispatch({
          type: UPDATE_INVITE_INFO_SUCCESS,
          successMessage: i18n.t('popup.inviteUpdated'),
          res,
        }),
      (err) =>
        dispatch({
          type: UPDATE_INVITE_INFO_FAILURE,
          err,
        }),
    ),
  });

export const clearInviteInfo = (dispatch) =>
  dispatch({
    type: CLEAR_INVITE_INFO,
  });

export const getVisitorInfoById = (dispatch, visitorId) =>
  dispatch({
    type: GET_VISITOR_INFO_BY_ID_REQUEST,
    payload: apiClient.visitors.getById(visitorId).then(
      (res) => {
        dispatch({
          type: GET_VISITOR_INFO_BY_ID_SUCCESS,
          visitorId,
          res,
        });
        return res.data;
      },
      (err) =>
        dispatch({
          type: GET_VISITOR_INFO_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const getVisitorsListByCreatorId = (dispatch, queryParams = {}) =>
  dispatch({
    type: GET_VISITOR_INFO_BY_CREATOR_ID_REQUEST,
    payload: apiClient.visitors.get(queryParams).then(
      (res) => {
        dispatch({
          type: GET_VISITOR_INFO_BY_CREATOR_ID_SUCCESS,
          res,
        });
        return res.data;
      },
      (err) =>
        dispatch({
          type: GET_VISITOR_INFO_BY_CREATOR_ID_FAILURE,
          err,
        }),
    ),
  });

export const logVisitorEntry = (dispatch, visitorId) =>
  dispatch({
    type: LOG_VISITOR_ENTRY_REQUEST,
    payload: apiClient.visitors.logEntry(visitorId).then(
      (res) => {
        dispatch({
          type: LOG_VISITOR_ENTRY_SUCCESS,
          visitorId,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: LOG_VISITOR_ENTRY_FAILURE,
          err,
        }),
    ),
  });

export const confirmToBePermanent = (dispatch, type) => {
  const modalProps = {
    bodyText: i18n.t('popup.permanentNote', { type }),
    onConfirm: () => {},
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: INFO,
    modalProps,
  });
};
